import { Clive, Typography } from "@eventr/common-storybook";
import { Stack } from "@mui/material";
import i18n from "../../i18n/i18next";

export const NoOrg = () => {
  return (
    <Stack
      direction="column"
      sx={{
        height: "100%",
        justifyContent: "center",
        width: "100%"
      }}>
      <Typography id="noTeamText" variant="bodyBold" sx={{
        textAlign: "center"
      }}>
        {i18n.t("account.noTeam")}
      </Typography>
      <Typography
        id="headToAccountPageText"
        variant="bodyRegular"
        sx={{
          textAlign: "center",
          whiteSpace: "pre-line"
        }}>
        {i18n.t("account.noTeamCreate")}
      </Typography>
      <Stack sx={{
        alignItems: "center"
      }}>
        <Clive />
      </Stack>
    </Stack>
  );
};
